import React from 'react'

import { Stack } from '@mui/material'

import Video from './Video';


const RelatedVideo= ({data}) => {

  
  return (
   <>
     <Stack direction="column" flexWrap="wrap" justifyContent="center" gap={2}>
   {
     data?.map((e,idx)=>(
       <Video e={e} idx={idx} key={idx}/>
     ))
}
     </Stack>
</>
  )
}

export default RelatedVideo